import React from 'react';
import axios from 'axios';
// import clerk from '../utils/clerk';
import ProfilePic from '../ProfilePicTemp.png';
import { getToken } from '../hooks/AuthProvider';

interface creator {
    username: string;
    displayName: string;
    pic: string;
    creatorDetails: {
        username: string;
        displayName: string;
    }
}

type props = {};
type state = {
    creators: creator[];
};

class ExploreComponent extends React.Component<props, state> {
    constructor(props: any) {
        super(props);
        this.state = {
            creators: []
        }
    }

    componentDidMount() {
        // Make request to API to fetch creators
        // clerk.session?.getToken().then(async (token: any) => {
        axios.get(`${process.env.REACT_APP_API_URL}api/v1/explore`, { headers: { 'x-auth-token': getToken() } }).then((res: any) => {
            console.log(res.data);
            this.setState({ creators: res.data.creators});
        })
        // });
    }

    render() {
        // return (
        //     <div className="bg-gray-800 flex w-full h-full my-2 p-2 rounded-md">
        //         {this.state.creators.length > 0 ? (
        //             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
        //                 {this.state.creators.map((creator: any) => (
        //                     <div key={creator.username} className="bg-gray-700 p-4 rounded-md shadow-md hover:shadow-lg transition-all">
        //                         {(() => {
        //                             if (creator.pic !== "") {
        //                                 return <img
        //                                     src={creator.pic}
        //                                     alt={creator.creatorDetails.displayName}
        //                                     className="min-h-16 min-w-16 object-cover rounded-full mb-4"
        //                                 />
        //                             } else {
        //                                 return <img
        //                                     src={ProfilePic}
        //                                     alt={creator.creatorDetails.displayName}
        //                                     className="min-h-16 min-w-16 object-cover rounded-full mb-4"
        //                                 />
        //                             }
        //                         })()}
        //                         <h3 className="text-xl font-semibold text-white">{creator.creatorDetails.displayName}</h3>
        //                         <button className="bg-red-600 text-white px-4 py-2 rounded-md mt-4 font-bold w-full">View Profile</button>
        //                     </div>
        //                 ))}
        //             </div>
        //         ) : (
        //             <div className="flex justify-center text-center text-gray-400 w-full">
        //                 <p>No creators found.</p>
        //             </div>
        //         )}
        //     </div>
        // );

        return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
            {this.state.creators.map((creator) => (
                // bg-zinc-900
                <div key={creator.username} className="bg-gray-800 border border-zinc-800 rounded-lg overflow-hidden">
                <div className="p-6">
                    <div className="flex items-center gap-4">
                        <img
                            src={creator.pic || "/placeholder.svg"}
                            alt={creator.creatorDetails.displayName}
                            width={60}
                            height={60}
                            className="rounded-full"
                        />
                        <div>
                            <div className="flex items-center gap-2">
                                <h3 className="font-semibold"><i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" /> {creator.creatorDetails.username}</h3>
                            </div>
                                <p className="text-sm text-zinc-400">{creator.creatorDetails.username}</p>
                        </div>
                    </div>
                    <div className="flex gap-4 text-sm mt-4">
                        <div>
                            {/* <span className="font-semibold">{creator.followers}</span>
                            <span className="text-zinc-400 ml-1">Followers</span> */}
                        </div>
                        <div>
                            {/* <span className="font-semibold">{creator.following}</span>
                            <span className="text-zinc-400 ml-1">Following</span> */}
                        </div>
                    </div>
                    <button onClick={() => window.location.href = `${process.env.REACT_APP_URL}app/user/${creator.creatorDetails.username}`} className="w-full bg-red-600 hover:bg-red-500 text-white font-medium py-2 rounded-md mt-4 transition-colors">View Profile</button>
                </div>
                </div>
            ))}
        </div>
    }
}

export default function Explore() {
    // const creators = [
    //     {
    //       id: 1,
    //       name: "Sarah Creative",
    //       handle: "@sarahcreates",
    //       followers: "12.5K",
    //       following: 245,
    //       verified: true,
    //       avatar: "/placeholder.svg?height=100&width=100",
    //     },
    //     {
    //       id: 2,
    //       name: "Digital Artist",
    //       handle: "@digitalart",
    //       followers: "45.2K",
    //       following: 129,
    //       verified: true,
    //       avatar: "/placeholder.svg?height=100&width=100",
    //     },
    //     {
    //       id: 3,
    //       name: "Tech Creator",
    //       handle: "@techcreator",
    //       followers: "8.9K",
    //       following: 432,
    //       verified: false,
    //       avatar: "/placeholder.svg?height=100&width=100",
    //     },
    //     {
    //       id: 4,
    //       name: "Gaming Pro",
    //       handle: "@gamingpro",
    //       followers: "22.1K",
    //       following: 156,
    //       verified: true,
    //       avatar: "/placeholder.svg?height=100&width=100",
    //     },
    //     {
    //       id: 5,
    //       name: "Music Producer",
    //       handle: "@musicpro",
    //       followers: "33.7K",
    //       following: 289,
    //       verified: true,
    //       avatar: "/placeholder.svg?height=100&width=100",
    //     },
    //     {
    //       id: 6,
    //       name: "Food Creator",
    //       handle: "@foodie",
    //       followers: "15.3K",
    //       following: 178,
    //       verified: false,
    //       avatar: "/placeholder.svg?height=100&width=100",
    //     },
    // ]

    return <div className="col-span-2 mx-4 mt-4">
        <h1 className="text-2xl font-bold">Explore Creators</h1>
        <ExploreComponent />
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
            {creators.map((creator) => (
                <div key={creator.id} className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden">
                  <div className="p-6">
                    <div className="flex items-center gap-4">
                      <img
                        src={creator.avatar || "/placeholder.svg"}
                        alt={creator.name}
                        width={60}
                        height={60}
                        className="rounded-full"
                      />
                      <div>
                        <div className="flex items-center gap-2">
                          <h3 className="font-semibold"><i className="fa-solid fa-badge-check text-sky-500" title="Verified Creator" /> {creator.name}</h3>
                        </div>
                        <p className="text-sm text-zinc-400">{creator.handle}</p>
                      </div>
                    </div>
                    <div className="flex gap-4 text-sm mt-4">
                      <div>
                        <span className="font-semibold">{creator.followers}</span>
                        <span className="text-zinc-400 ml-1">Followers</span>
                      </div>
                      <div>
                        <span className="font-semibold">{creator.following}</span>
                        <span className="text-zinc-400 ml-1">Following</span>
                      </div>
                    </div>
                    <button className="w-full bg-red-500 hover:bg-red-600 text-white font-medium py-2 rounded-md mt-4 transition-colors">
                      Follow
                    </button>
                  </div>
                </div>
            ))}
        </div> */}
    </div>
}